<div class="workflow-hierarchy-div">
    <div class="workflow-tools-div">
        <div class="workflow-tool-div"
             draggable
             [dragScope]="'addWorkflow'"
             [dragData]="null">
            <!-- Note:  the following can be dragged onto the workflow hierarchy. -->
            <mat-icon class="workflow-tool-mat-icon"
                      matTooltip="{{this.AddWorkflowToHierarchyTooltip}}"
                      [matTooltipPosition]="this.TooltipPosition">timeline</mat-icon>
        </div>

        <div class="workflow-tool-div"
             droppable
             [dropScope]="'removeWorkflow'"
             (onDrop)="this.onWorkflowDroppedOnTrash($event)">
            <!-- Note:  workflows in the hierarchy can be dragged here to delete them. -->
            <mat-icon svgIcon="trash"
                      class="workflow-tool-mat-icon workflow-tool-svg-mat-icon"
                      matTooltip="{{this.TrashTooltip}}"
                      [matTooltipPosition]="this.TooltipPosition"></mat-icon>
        </div>
    </div>

    <div class="workflows-in-hierarchy-div">
        <ng-container *ngFor="let hierarchyWorkflow of this.WorkflowsInHierarchy; let i=index">
            <div *ngIf="i == 0"
                 droppable
                 [dropScope]="'addWorkflow'"
                 (onDrop)="this.onWorkflowDroppedOnHierarchy($event,i,false)"
                 class="workflow-gap-div"></div>

            <div class="workflow-in-hierarchy-div"
                 draggable
                 [dragScope]="'removeWorkflow'"
                 [dragData]="i">
                <mat-form-field class="workflow-in-hierarchy-mat-form-field">
                    <mat-label>Workflow</mat-label>

                    <mat-select [(value)]="hierarchyWorkflow.id"
                                (selectionChange)="this.workflowSelectionChanged(i,$event)">
                        <mat-option *ngFor="let siteWorkflow of this.SiteWorkflows"
                                    [value]="siteWorkflow.id">
                            {{siteWorkflow.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div droppable
                 [dropScope]="'addWorkflow'"
                 (onDrop)="this.onWorkflowDroppedOnHierarchy($event,i,true)"
                 class="workflow-gap-div"></div>
        </ng-container>

        <!-- If there are no workflows in the hierarchy, create a single drop zone. -->
        <div *ngIf="this.NoWorkflowsInHierarchy"
             droppable
             [dropScope]="'addWorkflow'"
             (onDrop)="this.onWorkflowDroppedOnHierarchy($event,0,true)"
             class="workflow-gap-div"></div>
    </div>
</div>
